// Copyright (c) 2016 Deere & Company

import {
    createErrorMessage,
    createInfoMessage,
    createSuccessMessage,
    createWarningMessage,
    deleteErrorMessage,
    deleteInfoMessage,
    deleteSuccessMessage,
    deleteWarningMessage,
    dismissErrorMessages,
    dismissInfoMessages,
    dismissSuccessMessages,
    dismissWarningMessages
} from '../../shared/action-creators/alert-messages';
import {
    setAppConfig,
    updateSelectedSapEnvironment
} from '../../app-config/action-creators/';
import {goToSearchView} from './go-to-search-view';
import {onHeaderSearch} from './header-search';
import {readClaimTypes} from './claim-types';
import {readFavorites} from '../../shared/components/favorites/action-creators/read-favorites';
import {readLinks} from './links';
import {readSubClaimTypes} from './sub-claim-types';
import userActionCreators from '../../user/shared/action-creators';

export default {
    ...userActionCreators,
    createErrorMessage,
    createInfoMessage,
    createSuccessMessage,
    createWarningMessage,
    deleteErrorMessage,
    deleteInfoMessage,
    deleteSuccessMessage,
    deleteWarningMessage,
    dismissErrorMessages,
    dismissInfoMessages,
    dismissSuccessMessages,
    dismissWarningMessages,
    goToSearchView,
    onHeaderSearch,
    readClaimTypes,
    readFavorites,
    readLinks,
    readSubClaimTypes,
    setAppConfig,
    updateSelectedSapEnvironment
};



// WEBPACK FOOTER //
// ./src/app/action-creators/index.js